import React from "react";
import api from "@/lib/apiClient";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Erro na tela:", error, info?.componentStack);
    let role = null;
    try { role = JSON.parse(atob(((localStorage.getItem("cb_token") || "").split(".")[1] || "").replace(/-/g, "+").replace(/_/g, "/"))).role; } catch (e) { /* sem token */ }
    api.post("/client-errors", {
      message: String(error?.message || error).slice(0, 2000),
      stack: `${error?.stack || ""}\n--- componentes ---${info?.componentStack || ""}`.slice(0, 8000),
      path: window.location.pathname, role,
    }).catch(() => {});
  }

  logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white rounded-xl border border-slate-200 p-6 space-y-3 text-center">
          <h1 className="text-lg font-semibold text-[#0a2a6c]">Não foi possível abrir esta tela</h1>
          <p className="text-sm text-slate-600">Tente recarregar. Se continuar, envie um print desta mensagem ao suporte.</p>
          <p className="text-xs text-red-600 bg-red-50 rounded-md p-2 break-words" data-testid="error-boundary-message">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <div className="flex gap-2 justify-center">
            <button className="rounded-md bg-[#1e7be0] text-white text-sm px-4 py-2" onClick={() => window.location.reload()}
              data-testid="error-boundary-reload">Recarregar</button>
            <button className="rounded-md border border-slate-300 text-sm px-4 py-2" onClick={this.logout}
              data-testid="error-boundary-logout">Sair e entrar de novo</button>
          </div>
        </div>
      </div>
    );
  }
}
